import React from 'react';
import { FilterColumnProps } from '../types';
import { FilterOperator } from '../../../interfaces/sessions';
import { Typography } from '../../../interfaces/typography';

export function NumericalFilter({ value, onChange }: FilterColumnProps) {
  const operator = value.operator;
  const currentValue = value.value_safe;

  // For range operators (GT, GE, LT, LE), show single input
  // For IN/NIN operators, show multi-value input
  // For EQ/NEQ, show single input
  
  const isRangeOperator = [FilterOperator.GT, FilterOperator.GE, FilterOperator.LT, FilterOperator.LE, FilterOperator.EQ, FilterOperator.NEQ].includes(operator);
  const isMultiValueOperator = [FilterOperator.IN, FilterOperator.NIN].includes(operator);

  const handleSingleValueChange = (newValue: string) => {
    const numericValue = newValue === '' ? null : parseFloat(newValue);
    onChange({
      ...value,
      value_safe: numericValue
    });
  };

  const handleMultiValueChange = (newValue: string) => {
    // Parse comma-separated values
    const values = newValue
      .split(',')
      .map(v => v.trim())
      .filter(v => v !== '')
      .map(v => parseFloat(v))
      .filter(v => !isNaN(v));
      
    onChange({
      ...value,
      value_safe: values
    });
  };

  if (isRangeOperator) {
    return (
      <div className="w-full">
        <input
          type="number"
          value={currentValue || ''}
          onChange={(e) => handleSingleValueChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter number..."
          step="any"
          style={{
            fontSize: '13px',
            fontFamily: 'Calibri,Arial,Helvetica,sans-serif'
          }}
        />
      </div>
    );
  }

  if (isMultiValueOperator) {
    const displayValue = Array.isArray(currentValue) ? currentValue.join(', ') : '';
    
    return (
      <div className="w-full">
        <input
          type="text"
          value={displayValue}
          onChange={(e) => handleMultiValueChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter numbers separated by commas..."
          style={{
            fontSize: '13px',
            fontFamily: 'Calibri,Arial,Helvetica,sans-serif'
          }}
        />
        <div className="mt-1">
          <Typography variant="smallParagraph" color="#6B7280">
            Separate multiple values with commas (e.g., 1, 2.5, 10)
          </Typography>
        </div>
      </div>
    );
  }

  // Fallback for unknown operators
  return (
    <div className="w-full">
      <input
        type="number"
        value={currentValue || ''}
        onChange={(e) => handleSingleValueChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder="Enter number..."
        step="any"
        style={{
          fontSize: '13px',
          fontFamily: 'Calibri,Arial,Helvetica,sans-serif'
        }}
      />
    </div>
  );
} 